export default "__VITE_ASSET__7a8021cd__"